import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';

import { Observable, Subject } from 'rxjs';

import { CommandRelay } from '../../commands/command-relay.class';

import { BootstrapPopupService } from '../services/bootstrap-popup.service';

@Component({
	selector: 'bootstrap-popup',
	templateUrl: 'bootstrap-popup.html',
	// styleUrls: ['bootstrap-popup.css']
})
export class BootstrapPopupComponent {
	private previousPopupId: string | null = null;
	
	constructor(
		@Inject(BootstrapPopupService) private service: BootstrapPopupService,
	) {
	}

	@Input() id!: string;
	@Input() title!: string;
	@Input() htmlTitle: string | null = null;
	@Input() modalSize: string = 'modal-xl';
	@Input() windowCloseButton = false;
	
	@Output() closed = new EventEmitter<void>();

	// Liaison de l'observable servant a commander l'affichage ou la cloture du composant
	private displayRelay = new CommandRelay<boolean>(show => show ? this.open() : this.close());
	private _obs: Observable<boolean> | undefined;
	@Input() set displaySubject(obs: Observable<boolean> | undefined) {
		this.displayRelay.register(obs);
		this._obs = obs;
	}
	
	closeRequested() {
		// Si l'utilisateur clique sur la croix de fermeture et que l'observable est un sujet, on reemet
		// la valeur "false" pour que le parent la recoive eventuellement aussi
		if (this._obs instanceof Subject) {
			let subject = this._obs as Subject<boolean>;
			subject.next(false);
		} else {
			close();
		}
	}
	
	open() {
		// FIX 54315
		// Quand on ouvre une pop-up, il faut masquer temporairement la pop-up
		// precedente s'il y en a une affichee, car en effet, le focus
		// du scrolling peut sinon etre perdu sur la premiere pop-up quand la
		// nouvelle pop-up se fermera
		let previousPopupId = this.service.getCurrentPopupId();
		if (previousPopupId !== this.id) {
			this.previousPopupId = this.service.getCurrentPopupId();
			if (this.previousPopupId) {
				$('#' + this.previousPopupId).modal('hide');
			}
			
			$('#' + this.id).modal('show');
			this.service.setCurrentPopupId(this.id);
		} else {
			$('#' + this.id).modal('show');
		}
	}
	
	close() {
		$('#' + this.id).modal('hide');

		// FIX 54315
		// Suite a le modification ci-dessus, il faut automatiquement re-afficher
		// la pop-up precedente quand on ferme celle-ci
		if (this.previousPopupId) {
			$('#' + this.previousPopupId).modal('show');
		}
		this.service.setCurrentPopupId(this.previousPopupId);
		
		this.closed.emit();
	}
}